import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-employee-report-modal',
  templateUrl: './employee-report-modal.component.html',
  styleUrls: ['../modal.component.scss']
})
export class EmployeeReportModalComponent {
  @Output() readonly responseChanged = new EventEmitter();
  fromDate: Date = new Date();
  toDate: Date = new Date();

  constructor() {
    // Set fromDate 30 days before
    const today = new Date();
    today.setDate(today.getDate() - 30);
    this.fromDate = today;
  }

  onSelectDateFrom(event: Date): void {
    this.fromDate = event;
  }

  onSelectDateTo(event: Date): void {
    this.toDate = event;
  }

  emitTrue(): void {
    this.responseChanged.emit({ fromDate: this.fromDate, toDate: this.toDate });
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}
